import packageJson from '../../../package.json';

export default function createId(id: string) {
  const name = packageJson.name.replace(/[@]/g, '').replace(/\//g, '-');
  return `${name}__${id}`;
}
